// removed by extract-text-webpack-plugin
module.exports = {"hidden":"dots__hidden--22G6b","dots":"dots__dots--2KyA-","dot":"dots__dot--2-lyP","dotActive":"dots__dotActive--h0ulZ dots__dot--2-lyP","noTransition":"dots__noTransition--3Iukf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Dots/dots.css
// module id = 0htb
// module chunks = 0